import { TabContext, TabContextValue } from '@components/providers';
import { useContext } from 'react';

const useTabContext = (): TabContextValue | undefined => {
  return useContext(TabContext);
};

export default useTabContext;
